<script setup lang="ts">
import { getCurrentInstance, onMounted } from 'vue';
import GlobalSearchMain from './views/GlobalSearchMain.vue';
import { storeToRefs } from 'pinia';
import { useGlobalSearchStore } from './stores';
const globalStore = useGlobalSearchStore();
const { globalProperties } = storeToRefs(globalStore);
onMounted(() => {
    const currentInstance = getCurrentInstance();
    globalProperties.value = currentInstance?.appContext.config.globalProperties as any;
});
</script>

<template>
    <GlobalSearchMain class="global-search-main" el-id="popup-app" />
</template>

<style lang="scss">
@use 'sass:meta';

.global-search-main,
.tess-more-action-menu {
    overflow: hidden;
    @include meta.load-css('./assets/styles/index.scss');
    @include meta.load-css('./assets/styles/common.scss');
}
</style>
<style lang="scss">
.tess-more-action-menu {
    transition: opacity 0.3s ease;
    display: flex;
    flex-direction: column;
    background-color: #f3f4f8;
    position: fixed;
    box-shadow: 0px 4px 4px 0px #00000040;
    z-index: 999;
    opacity: 0;
    width: 200px;
}
</style>
